import { SVGProps } from 'react';

export const UnableToLoadGenericIllustration = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="150"
            height="150"
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clip-path="url(#clip0_1526_6985)">
                <path
                    d="M74.757 150C116.044 150 149.514 116.53 149.514 75.2428C149.514 33.9557 116.044 0.48584 74.757 0.48584C33.4698 0.48584 0 33.9557 0 75.2428C0 116.53 33.4698 150 74.757 150Z"
                    fill="#E6F0F9"
                />
                <path
                    d="M124.319 37.5081V122.796H29.6436V0H86.8107L124.319 37.5081Z"
                    fill="#A8D0FF"
                />
                <path d="M86.8105 37.5081H124.319L86.8105 0V37.5081Z" fill="#196CF2" />
                <path
                    d="M124.374 143.089C135.572 143.089 144.649 134.012 144.649 122.815C144.649 111.617 135.572 102.54 124.374 102.54C113.177 102.54 104.1 111.617 104.1 122.815C104.1 134.012 113.177 143.089 124.374 143.089Z"
                    fill="#F94D32"
                />
                <path
                    d="M126.513 124.416L127.263 111.062H120.861L121.666 124.416H126.513Z"
                    fill="white"
                />
                <path
                    d="M124.286 127.703C123.806 127.685 123.327 127.765 122.878 127.937C122.429 128.109 122.019 128.37 121.674 128.703C121.328 129.037 121.052 129.437 120.864 129.88C120.676 130.322 120.58 130.798 120.58 131.279C120.58 131.759 120.676 132.235 120.864 132.678C121.052 133.12 121.328 133.52 121.674 133.854C122.019 134.188 122.429 134.448 122.878 134.62C123.327 134.792 123.806 134.872 124.286 134.854C124.775 134.885 125.264 134.815 125.724 134.649C126.185 134.483 126.606 134.225 126.963 133.89C127.319 133.555 127.603 133.15 127.798 132.701C127.992 132.252 128.092 131.768 128.092 131.279C128.092 130.789 127.992 130.305 127.798 129.856C127.603 129.407 127.319 129.003 126.963 128.668C126.606 128.333 126.185 128.074 125.724 127.908C125.264 127.742 124.775 127.672 124.286 127.703Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1526_6985">
                    <rect width="149.514" height="150" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
